import { useBotStore } from '@/stores/ftbotwrapper';
import type { AuthPayload } from '@/types';

export const useAutoLogin = () => {
  const botStore = useBotStore();

  const backtestingServerConfig: AuthPayload = {
    botName: 'backtesting',
    url: 'https://webservice.xiex.io',
    username: 'freqtrader',
    password: '12345678',
  };

  const attemptAutoLogin = async (force = false): Promise<boolean> => {
    try {
      const existingBot = Object.values(botStore.availableBots).find(
        (bot) => bot.botUrl === backtestingServerConfig.url,
      );

      if (existingBot && !force) {
        console.log('Backtesting server already configured');
        return true;
      }

      const botId = existingBot ? existingBot.botId : botStore.nextBotId;
      const { login } = useLoginInfo(botId);

      await login(backtestingServerConfig);

      if (!existingBot) {
        const sortId = Object.keys(botStore.availableBots).length + 1;
        botStore.addBot({
          botName: backtestingServerConfig.botName,
          botId,
          botUrl: backtestingServerConfig.url,
          sortId: sortId,
        });
      }

      botStore.selectBot(botId);
      botStore.allRefreshFull();

      return true;
    } catch (error) {
      console.error('Auto-login failed:', error);
      return false;
    }
  };

  return {
    attemptAutoLogin,
    backtestingServerConfig,
  };
};
